import styled, { css } from 'styled-components';
import Button from '../../../_shared/components/Button';
import applyResponsiveVdpStyles from '../../../_shared/helpers/applyResponsiveVdpStyles';

/**
 * Variant Definitions
 */
const StyledFooterVariants = {
  mini: css`
    display: none;
  `,
  expanded: css`
    display: block;
  `
};

/**
 * Styled Components
 */
export const StyledFooter = styled.footer`
  width: 100%;
  margin: 48px 0 48px;
  ${({ theme }) =>
    applyResponsiveVdpStyles(theme, {
      mini: StyledFooterVariants.mini,
      expanded: StyledFooterVariants.expanded
    })}
`;

export const FooterButton = styled(Button.Secondary)`
  display: block;
  border: 2px solid ${({ theme }) => theme.COLORS.BASE_INVERTED};
  margin: 24px auto;

  a {
    text-decoration: none;
    color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  }

  &:hover a {
    color: ${({ theme }) => theme.COLORS.DARK_BLUE};
  }
`;
